import script from "./TexturedButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TexturedButton.vue?vue&type=script&setup=true&lang=js"

import "./TexturedButton.vue?vue&type=style&index=0&id=71096e5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71096e5f"]])

export default __exports__